import { useOutletContext } from "react-router-dom";
import Header from "user/components/common/Header";
import Progressbar from "./-components/Progressbar";
import { OutletContextProps } from "./-components/formik-utils";
import InputField, { MobileInputField } from "user/components/common/InputField";
import RefreshRedirect from "./-components/RefreshRedirect";
import useOverlay, { OverlayWrapper } from "common/hooks/user/useOverlay";
import { cancelMessage, SystemPopup } from "user/components/common/Overlay";

const progressStep = 1;

export default function From({ update = false }: { update?: boolean }) {
    const { overlay, openOverlay, closeOverlay } = useOverlay();
    const context = useOutletContext<OutletContextProps>();
    const { values, handleSubmit, handleChange, setFieldValue, touched, errors } = context.formik.from;
    const errorKeys = Object.keys(errors);
    const isInValid = errorKeys.length > 0;

    return (
        <RefreshRedirect customerIdx={values.customer_idx} isUpdate={update}>
            <OverlayWrapper overlay={overlay} closeOverlay={closeOverlay}>
                <div className="h-full flex flex-col">
                    <Header
                        title="1. 주문하시는 분"
                        goBack
                        onClickClose={() => openOverlay(<SystemPopup isConfirm message={cancelMessage(update)} onClickClose={closeOverlay} />)}
                    />

                    <div className="wrapper flex-1 flex flex-col">
                        <Progressbar step={progressStep} />

                        <form className="flex-1 flex flex-col justify-between py-[16px]" onSubmit={handleSubmit}>
                            <div className="flex flex-col gap-[16px]">
                                <div>
                                    <p>회사</p>
                                    <p className="py-[12px]">{values.customer_name}</p>
                                </div>

                                <div>
                                    <label htmlFor="order_name" className="text-[#484964] inline-block mb-[4px]">
                                        이름 <span className="text-[#4B632B] ml-[8px]">*</span>
                                    </label>

                                    <InputField
                                        id="order_name"
                                        name="order_name"
                                        value={values.order_name}
                                        onChange={handleChange}
                                        placeholder="이름을 입력해주세요"
                                        error={touched.order_name && errorKeys.includes("order_name")}
                                        onClickClearButton={() => setFieldValue("order_name", "")}
                                        textMaxLength={20}
                                        autoComplete="off"
                                    />
                                    {touched.order_name && errors.order_name && (
                                        <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">{errors.order_name}</div>
                                    )}
                                </div>

                                <div>
                                    <div>
                                        <label htmlFor="order_mobile" className="text-[#484964] inline-block mb-[4px]">
                                            연락처 <span className="text-[#4B632B] ml-[8px]">*</span>
                                        </label>

                                        <MobileInputField
                                            id="order_mobile"
                                            name="order_mobile"
                                            value={values.order_mobile}
                                            onChange={handleChange}
                                            placeholder="연락처를 입력해주세요"
                                            error={touched.order_mobile && errorKeys.includes("order_mobile")}
                                            onClickClearButton={() => setFieldValue("order_mobile", "")}
                                            autoComplete="off"
                                        />
                                        {touched.order_mobile && errors.order_mobile && (
                                            <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">{errors.order_mobile}</div>
                                        )}

                                        <div className="mt-[8px] bg-[#F8F9F7] rounded-[12px] text-[#4B632B] py-[16px] text-center">
                                            입력하신 연락처로 주문 알림톡이 전송됩니다.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button
                                type="submit"
                                data-disabled={isInValid}
                                className="bg-[#273219] font-bold text-white rounded-[12px] text-[18px] leading-[28px] py-[12px] w-full data-[disabled='true']:opacity-[0.4]"
                            >
                                다음
                            </button>
                        </form>
                    </div>
                </div>
            </OverlayWrapper>
        </RefreshRedirect>
    );
}
